/**
 * The household of a door: every elector with their age band and turnout —
 * as a written badge, never colour alone (`docs/CONVENTIONS.md` §4 and the
 * jlm2027-style charter).
 */
import { Badge } from '../../../components/ui';
import type { BadgeTone } from '../../../components/ui';
import { t } from '../../../i18n/fr';
import { TURNOUT_LABEL_KEYS } from '../labels';

import type { HouseholdMember } from '../../../api/types';

export interface HouseholdListProps {
  members: HouseholdMember[];
}

const TURNOUT_TONE: Record<HouseholdMember['turnout'], BadgeTone> = {
  voted: 'green',
  abstained: 'red',
  unknown: 'neutral',
};

/**
 * Render every elector of a household, each with a written turnout badge.
 *
 * @param props - The household's electors.
 * @returns The household list element.
 */
export function HouseholdList({ members }: HouseholdListProps) {
  if (members.length === 0) {
    return <p className="muted">{t('household.sheet.householdEmpty')}</p>;
  }

  return (
    <div className="household-members">
      {members.map((member, index) => (
        <p key={`${member.last_name}-${member.first_names}-${index}`} className="household-member">
          <b>
            {member.last_name.toUpperCase()} {member.first_names}
          </b>{' '}
          · {member.age_band ? `${member.age_band} ans` : t('household.sheet.ageBandUnknown')}{' '}
          <Badge tone={TURNOUT_TONE[member.turnout]}>{t(TURNOUT_LABEL_KEYS[member.turnout])}</Badge>
        </p>
      ))}
    </div>
  );
}
